var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3033 4.6967C21.7098 6.10322 22.5 8.01088 22.5 10C22.5 18.75 26.25 21.25 26.25 21.25H3.75C3.75 21.25 7.5 18.75 7.5 10C7.5 8.01088 8.29018 6.10322 9.6967 4.6967C11.1032 3.29018 13.0109 2.5 15 2.5C16.9891 2.5 18.8968 3.29018 20.3033 4.6967Z",
    stroke: "#B4D4FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1625 26.25C16.9427 26.6288 16.6273 26.9433 16.2478 27.1619C15.8683 27.3805 15.438 27.4956 15 27.4956C14.562 27.4956 14.1317 27.3805 13.7522 27.1619C13.3727 26.9433 13.0573 26.6288 12.8375 26.25",
    stroke: "#B4D4FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.343110162f174c7099404283f4a7b1e2.svg";
export { ForwardRef as ReactComponent };